export const hublinkRoutes = [
  {
    path: '/hublink/participate',
    name: 'nft_event_participate',
    component: () => import('@/views/hublink/PromotionParticipate.vue'),
  },
  {
    path: '/hublink/middleware',
    name: 'nft_event_middleware',
    component: () => import('@/views/hublink/PromotionMiddleware.vue'),
  },
  {
    path: '/hublink/attend_duplicated',
    name: 'nft_event_duplicate',
    component: () => import('@/views/hublink/PromotionDupAttend.vue'),
  },
  {
    path: '/hublink/invalid_quantity',
    name: 'nft_event_quantity',
    component: () => import('@/views/hublink/PromotionInvalidQuantity.vue'),
  },
  {
    path: '/hublink/attend_complete',
    name: 'nft_event_attended',
    component: () => import('@/views/hublink/PromotionAttendComplete.vue'),
  },
  {
    path: '/hublink/already_minted',
    name: 'nft_event_minted',
    component: () => import('@/views/hublink/PromotionAlreadyMinted.vue'),
  },
  {
    path: '/hublink/mint_complete',
    name: 'nft_event_completed',
    component: () => import('@/views/hublink/PromotionMintComplete.vue'),
  },
]
